import { Route, Routes } from 'react-router-dom'

import About from './components/About'
import Contact from './components/Contact'
import Layout from './components/Layout'
import Portfolio from './components/Portfolio'
import DreamsIT from './components/Portfolio/DreamsIT'
import DreamsRetail from './components/Portfolio/DreamsRetail'
import TraineeProjectManager from './components/Portfolio/TraineeProjectManager'
import './App.scss'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<About />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/DreamsIT" element={<DreamsIT />} />
        <Route path="/portfolio/DreamsRetail" element={<DreamsRetail />} />
        <Route
          path="/portfolio/TraineeProjectManager"
          element={<TraineeProjectManager />}
        />
      </Route>
    </Routes>
  )
}

export default App
